import React from "react";
import { Col, Row } from "react-bootstrap";
import net from "../../Assets/net.png";
import render from "../../Assets/render.png";
import aws from "../../Assets/aws.png";
import { BsGithub } from "react-icons/bs";



function Deployments() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons" title="netlyfy">
        <img className="depimage" src={net} alt="netlyfy"/>
      </Col>

       <Col xs={4} md={2} className="tech-icons" title="render">
        <img className="depimage" src={render} alt="render"/>
      </Col>

       <Col xs={4} md={2} className="tech-icons" title="aws">
        <img className="depimage" src={aws} alt="aws"/>
      </Col>

       <Col xs={4} md={2} className="tech-icons" title="GitHub Pages">
        <BsGithub/>
      </Col>
      
  
    </Row>
  );
}

export default Deployments;
